import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Crown, Timer } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isAndroidTWA } from "@/utils/runtimeContext";

const ActiveTrialBanner: React.FC = () => {
  const { user, getTrialInfo } = useAuth();

  if (!user) return null;
  if (isAndroidTWA()) return null;

  const trialInfo = getTrialInfo();
  
  // Só mostra se está no período de teste ativo
  if (trialInfo.status !== 'trial_active') return null;

  return (
    <Card className="border-green-300 bg-gradient-to-r from-green-50 to-emerald-50 shadow-lg mb-6">
      <CardContent className="p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Timer className="h-8 w-8 text-green-600" />
            <div>
              <h3 className="font-bold text-green-800 text-lg">
                🎯 Período de Teste Ativo
              </h3>
              <p className="text-green-600 text-sm">
                {trialInfo.daysRemaining} dias restantes do teste gratuito para explorar todas as funcionalidades
              </p>
            </div>
          </div>
          <Link to="/planos">
            <Button className="bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-bold px-6 py-3 text-lg shadow-lg animate-pulse">
              <Crown className="w-5 h-5 mr-2" />
              ACESSO VIP
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActiveTrialBanner;